export function replaceAbstractText(str: string, replaceText: string | number | boolean, target: string) {
  return str.replace(target, replaceText.toString());
}
